import React from "react";
import { useMemo } from "react";
import { buildCls } from "../../utils/helpers/buildCls";

interface Props {
  children: React.ReactNode;
}

export default function CardsContainerFlex(props: Props) {
  const className = useMemo(() => {
    const cls = [
      "d-flex",
      "flex-column",
      "flex-md-row",
      "flex-wrap",
      "st-gap",
      "justify-content-around",
      "w-100"
    ];

    return buildCls(cls);
  }, [props]);

  return <div className={className}>{props.children}</div>;
}
